import gql from 'graphql-tag';

export const CREATE_STORY_AUDIENCE_ADS_MUTATION = gql`
  mutation CreateStoryAudienceAdsMutation(
    $creativeIds: [ID!]!
    $activateCampaign: Boolean
    $newFbCampaign: Boolean
    $startTime: String!
  ) {
    createStoryAudienceAds(
      creativeIds: $creativeIds
      activateCampaign: $activateCampaign
      newFbCampaign: $newFbCampaign
      startTime: $startTime
    ) {
      status
      errors
    }
  }
`;
